import React, { lazy, Suspense } from 'react';
import './App.css';
import Header from './components/header/Header';
import Home from './components/home/Home';

// Lazy load components below the fold
const About = lazy(() => import('./components/about/About'));
const Skills = lazy(() => import('./components/skills/Skills'));
const Portfolio = lazy(() => import('./components/portfolio/Portfolio'));
const Contact = lazy(() => import('./components/contact/Contact'));
const Footer = lazy(() => import('./components/footer/Footer'));

// Simple loading component
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '200px',
    color: 'var(--color-bg-variant)'
  }}>
    <div className="loading-spinner">Loading...</div>
  </div>
);

const App = () => {
  return (
    <>
    <Header/>
    <main className='main'>
      <Home/>
      <Suspense fallback={<LoadingSpinner />}>
        <About/>
        <Skills/>
        <Portfolio/>
        <Contact/>
        <Footer/>
      </Suspense>
    </main>
    </>
  )
  
}

export default App;